
























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module Helper
---------------------------------------- */

import { StoreModule } from "@store/service/Modules";
const module = new StoreModule('pages');

/* ----------------------------------------
    Sections
---------------------------------------- */

import ArticlesList from '@part/generic/ArticlesList.vue';
import Blocks from '@part/Blocks.vue';
import Contact from '@part/cases/Contact.vue';
import PageHeader from '@layout/header/PageHeader.vue';
import RelatedPages from '@part/generic/RelatedPages.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        ArticlesList,
        Blocks,
        Contact,
        PageHeader,
        RelatedPages
    },

    computed: {
        page() {
            const slug = this.$route.params.slug;
            return module.getters('getPageBySlug', slug);
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Page extends Vue {}

